import React from 'react';

import { TextField } from 'Containers/App/types';
import { ContentfulCustomMessage } from 'ContentfulDefaults/types/_shared';
import { useTextContext } from 'Contexts/textContext';
import { FormattedTooltipProps } from 'DesignLibrary/atoms';
import InfoBar, { InfoBarProps } from 'DesignLibrary/molecules/InfoBar';
import RichText, { type ReplacementVars } from 'Shared/RichText';
import Text from 'Shared/Text';
import { TextReplacements } from 'Utils/textReplacement';

export interface ContentfulInfoBarProps {
  field: string;
  vars?: ReplacementVars;
  headerVars?: (string | number)[];
  tooltips?: FormattedTooltipProps[];
  overrides?: InfoBarProps;
  textReplacements?: TextReplacements;
  showClaimsTooltip?: boolean;
  isProfileAudioEnabled?: boolean;
}

export const ContentfulInfoBar = (props: ContentfulInfoBarProps) => {
  const {
    field,
    vars,
    headerVars,
    tooltips = [],
    textReplacements,
    overrides,
    showClaimsTooltip = false,
    isProfileAudioEnabled = false,
  } = props;

  const { retrieveContentfulData } = useTextContext();

  const message = retrieveContentfulData<ContentfulCustomMessage>(field);
  const header = <Text field={`${field}.header` as TextField} vars={{ x: headerVars }} />;
  const claimsTooltipMessage = retrieveContentfulData<string>('claims_summary_bar.claims_data_tooltip');

  return message ? (
    <InfoBar
      text={
        <RichText
          inlineParagraphs
          field={`${field}.text` as TextField}
          vars={vars}
          toolTips={tooltips}
          textReplacements={textReplacements}
        />
      }
      header={header}
      buttons={[{ text: message.url_button_text, url: message.url }]}
      color={message.color || 'yellow'}
      icon={message.icon}
      key={field}
      showClaimsTooltip={showClaimsTooltip}
      isProfileAudioEnabled={isProfileAudioEnabled}
      claimsTooltipMessage={claimsTooltipMessage}
      {...overrides}
    />
  ) : null;
};
